import React from 'react'
import useScrollReveal from '../../hooks/useScrollReveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldHalved, faCookieBite, faKey, faUserShield, faClipboardCheck } from '@fortawesome/free-solid-svg-icons'

const ENCRYPTED_DEMO = [
  { field: 'Nom', plain: 'Jean Dupont', encrypted: 'U2FsdGVkX1+vuppp...' },
  { field: 'IBAN', plain: 'FR76 3000 6000 0112 3456 7890 189', encrypted: 'aGVsbG8gd29ybGQ9...' },
  { field: 'Solde', plain: '2 450,00 €', encrypted: 'WkRWa1ZtUXdNVlJ...' },
  { field: 'Montant', plain: '-82,40 €', encrypted: 'cXdlcnR5dWlvcGF...' },
]

const SECURITY_POINTS = [
  { icon: faShieldHalved, text: 'Chiffrement champ par champ sur toutes les données sensibles' },
  { icon: faCookieBite, text: 'Sessions sécurisées via des cookies protégés' },
  { icon: faKey, text: 'Historique des mots de passe pour empêcher la réutilisation' },
  { icon: faUserShield, text: "Contrôle d'accès basé sur les rôles" },
  { icon: faClipboardCheck, text: 'Surveillance des tentatives de connexion suspectes' },
]

export default function Security() {
  const [ref, isVisible] = useScrollReveal()

  return (
    <section id="security" className={`section-padding reveal${isVisible ? ' revealed' : ''}`} ref={ref}>
      <h2 className="section-title">Vos données, vraiment privées.</h2>
      <p className="section-subtitle">Chaque donnée sensible est chiffrée individuellement. Même nous ne pouvons pas les lire.</p>

      <div className="landing-security">
        <div className="landing-security__demo">
          <div className="landing-security__row landing-security__row--header">
            <div>Champ</div>
            <div>Votre vue</div>
            <div>En base de données</div>
          </div>
          {ENCRYPTED_DEMO.map((row, i) => (
            <div className="landing-security__row" key={i}>
              <div className="landing-security__field">{row.field}</div>
              <div className="landing-security__plain">{row.plain}</div>
              <div className="landing-security__encrypted">{row.encrypted}</div>
            </div>
          ))}
        </div>

        <div className="landing-security__points">
          {SECURITY_POINTS.map((point, i) => (
            <div className="landing-security__point" key={i}>
              <FontAwesomeIcon icon={point.icon} />
              <span>{point.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
